exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Cormorant+SC:700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Amatic+SC:700);", ""]);

// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n\n\n\n.site-title {\n    font-family: 'Cormorant SC', serif;\n    font-weight: 1000;\n    letter-spacing: 5px;\n    font-size: 60px;\n    margin: 0;\n    padding: 10px;\n    padding-left: 5%;\n    color: #722f37;\n    background-color: lightgrey;\n    margin-bottom: 5px;\n}\n\n.body {\n    height: calc(100% - 97.5px);\n}\n.ng-scope{\n    height: 100%;\n}\nhtml {\n    height: 100%;\n}\n\nbody {\n    margin: 0;\n    padding: 0;\n    height: 100%;\n}\n\na {\n    text-decoration: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader?{"ident":"postcss"}!./src/styles.css
// module id = ./node_modules/css-loader/index.js?{"sourceMap":false,"importLoaders":1}!./node_modules/postcss-loader/index.js?{"ident":"postcss"}!./src/styles.css
// module chunks = 2